import { lazy } from '@loadable/component';

export type { EditorFieldProps } from './Editor';

export default lazy(() => import('./Editor'));
